<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏标签管理</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showAddCateDialog(0, '新增标签')">添加标签</el-button>
            </el-col>
        </el-row>
        <div>
            <tree-table class="treeTable" :data="labelList.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"   :columns="columns" :selection-type="false" :expand-type="false"
                        show-index index-text="编号" border :show-row-hover="false" :is-fold="false"  >
                <template slot="order" slot-scope="scope" >
                    <el-tag v-if="scope.row.labelType !== undefined ">二级分类</el-tag>
                    <el-tag v-else type="success">一级分类</el-tag>
                </template>
                <template slot="image" slot-scope="scope" >
                        <img v-if="!(scope.row.image==null || scope.row.image==undefined)" :src="VUE_APP_CDN_URL+scope.row.image"  width="50px" height="50px" />
                </template>
                <template slot="operate" slot-scope="scope" >
                    <el-button size="mini" type="primary" v-if="scope.row.labelType !== undefined "  @click="showAddCateDialog(1, '编辑分类', scope.row)">编辑</el-button>
                </template>
            </tree-table>
        </div>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="addCateDialogVisible"  center @close="closeAddCateDialog" :close-on-click-modal="false">
                <el-form :model="addCateForm"  ref="cateForm">
                    <el-form-item label="一级分类" >
                        <el-select v-model="addCateForm.labelType" >
                            <el-option  v-for="label in labelList" :key="label.id" :value="label.id" :label="label.name"  >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称">
                            <el-input  v-model="addCateForm.name" clearable ></el-input>
                    </el-form-item>
                    <el-form-item label="图标">
                            <el-upload
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleImageSuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadIcon">
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1MB!</div>
                            <img v-if="addCateForm.image " :src="VUE_APP_CDN_URL+addCateForm.image" class="avatar"  width="100%" height="100%" >
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                            </el-upload>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                   <el-button type="primary" @click="confirmAddCateDialog">确 定</el-button>
                   <el-button type="info" @click="closeAddCateDialog">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[1, 3,5,10]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="labelList.length">
            </el-pagination>
        </el-row>

    </div>
</template>

<script>
    import {
        gameLabelSave,
        gameUpload,
        allGameLabels
    } from "@/http/api"
    export default {
        inject:['reload'],
        name: "GameLabelList",
        data() {
            return {
                dialogTitle: '',
                dialogType: 0,
                addCateDialogVisible:false,
                addCateForm: {
                    id:null,
                    labelType: null,
                    name:'',
                    image:null
               },
                columns: [{
                        label: '分类名称',
                        prop: 'name',
                        width:200
                    },
                    {   label: '分类级别',
                        type: 'template',
                        template: 'order',
                        width:100
                    },
                    {   label: '图标',
                        type: 'template',
                        template: 'image',
                        width:100
                    },
                    {   label: '操作',
                        type: 'template',
                        template: 'operate',
                        width:100}],
                labelList: [],
                subCategorySet:new Set(),
                queryInfo:{
                    pagesize:5,
                    pagenum:1,
                },
                //上传图片路径
                uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                headers: {},
            };
        },

        methods:{
            showAddCateDialog (_type, _title, _data) {
                this.dialogType = _type;
                this.dialogTitle = _title;
                this.addCateForm = {
                    id:null,
                    name:'',
                    labelType:null,
                    image:null
                };
                if(_data){
                   this.addCateForm={
                           id: _data.id,
                           name:_data.name,
                           image:_data.image,
                           labelType:_data.labelType
                        }
                }
                this.addCateDialogVisible = true
            },
            closeAddCateDialog () {
                this.addCateDialogVisible = false;
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            handleImageSuccess(response){
                this.addCateForm.image=response.info;
            },
            uploadIcon(){
                gameUpload().then().catch(function () {
                })
            },
            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
            },
            confirmAddCateDialog (){
                let _message = '';
                if(this.addCateForm.name==='' && this.addCateForm.subName ===''){
                    _message = '请填写分类名称'
                }
                if ( this.addCateForm.labelType === null  ||  this.addCateForm.labelType ===''){
                    _message ='请选择一级分类'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                let func = gameLabelSave;
                if(this.dialogType===0){
                        func({
                            name: this.addCateForm.name,
                            labelType: this.addCateForm.labelType,
                            image:this.addCateForm.image
                        }).then(resp=>{
                            this.reload();
                            if(resp.data.status===0){
                                this.closeAddCateDialog()
                            }
                        }).catch(function () {
                        })
                }else{ 
                        func({
                            id:this.addCateForm.id,
                            name: this.addCateForm.name,
                            labelType: this.addCateForm.labelType,
                            image:this.addCateForm.image
                        }).then(resp=>{
                            this.reload();
                            if(resp.data.status===0){
                                this.closeAddCateDialog()
                            }
                        }).catch(function () {
                        }) 
                } 
            },
        },
        mounted () {  
            //这里获取video地址
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
            this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        },
        created () {
            this.headers ={Authorization : this.$store.state.user.token};
            allGameLabels().then(resp=>{
                this.labelList = resp.data.info;
            });

        }
    }
</script>

<style lang="less" scoped>
    .treeTable{margin-top:15px;width:800px}
</style>
